<template>
	<inertia-head title="TRC AI Circle Latest Update" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC AI CIRCLE LATEST UPDATES</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						The Truly Rich Club AI Circle latest updates focus on leveraging AI for work, business, and everyday life — without feeling overwhelmed by the technology.
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">

		<button
			@click="
				$inertia.visit('/member/trc-ai-circle/latest-updates/'+trcAiCircleBlogDetails.ai_circle_blog_uuid, {
					preserveScroll: false,
				})
			"
			id="scroll_top"
			class="btn btn-secondary opacity-75 d-none"
		>
			<i class="fa fa-arrow-up"></i>
		</button>

		<button
			@click="
				$inertia.visit(route('member.trc-ai-circle.latest-updates'), {
					preserveScroll: false,
				})
			"
			class="btn btn-secondary opacity-75"
		>
			<i class="fa fa-arrow-left me-1"></i>Go Back
		</button>

		<div v-if="trcAiCircleBlogDetails!==null" class="row pb-4 justify-content-center">
			<!--START Posts -->
			<div class="col-xl-10 col-lg-10 col-md-10 mt-5">
				<div class="trc-ai-article-header">
					<h1 class="trc-ai-article-title">{{ trcAiCircleBlogDetails.blog_title }}</h1>
					<div class="fs-sm fw-medium text-muted">
						<span class="me-3 fs-xs">
							<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
							{{ trcAiCircleBlogDetails.date_start }}
						</span>
					</div>
				</div>
				<div>
					<div
						class="mb-4 bg-image text-center"
					>
					<img :src="trcAiCircleBlogDetails.blog_image_url" class="img-fluid w-100 rounded" alt="stock update image">
					</div>
				</div>
				<div v-if="trcAiCircleBlogDetails.vimeo_id" class="mb-4">
					<div class="embed-responsive">
						<iframe
							class="embed-responsive-item"
							:src="'https://player.vimeo.com/video/'+trcAiCircleBlogDetails.vimeo_id"
							allowfullscreen
						></iframe>
					</div>
				</div>
				<div class="trc-ai-article-body">
					<div style="white-space: pre; white-space:break-spaces;overflow: hidden;" v-html="trcAiCircleBlogDetails.blog_desc"></div>
				</div>
			</div>
			<hr class="d-xl-none" />
			<!-- END Posts -->

		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		trcAiCircleBlogDetails: Object,
	},
	setup(props) {
		const modal 					= ref(null);
		let trcAiCircleBlogDetails 		= ref(props.trcAiCircleBlogDetails[0]??null);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')


			window.addEventListener(
				'scroll',
				debounce((e) => {

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						document.getElementById('scroll_top').classList.add('d-none')
					}
				}, 100)
			)

		})

		
		return {
			modal,
			trcAiCircleBlogDetails
		}
	},
}
</script>

<style scoped>
.trc-ai-article-header {
	margin-bottom: 2rem;
}

.trc-ai-article-title {
	color: #343b45;
	font-size: clamp(2.25rem, 4.8vw, 4.5rem);
	font-weight: 700;
	line-height: 1.08;
	margin-bottom: 1rem;
}

.trc-ai-article-body {
	max-width: 860px;
	margin: 0 auto;
	font-size: 1.125rem;
	line-height: 1.7;
}

@media (max-width: 767.98px) {
	.trc-ai-article-header {
		margin-bottom: 1.5rem;
	}

	.trc-ai-article-title {
		font-size: 2.25rem;
	}
}
</style>
